import { KText } from '@/ui-library/components';
import { Center, ChakraProps, Flex } from '@chakra-ui/react';
import { StepConfig, StepLoader } from '@kula-ai/components';
import { Stars03 } from '@kula-ai/icons-core';

export const AiLoader = ({
  config = {
    steps: [],
    message: {
      title: '',
      description: '',
    },
  },
  defaultDuration = 2, // in seconds
  containerProps = {},
}: {
  containerProps?: ChakraProps;
  config: {
    steps: StepConfig[];
    message: {
      title: string;
      description: string;
    };
  };
  defaultDuration?: number;
}) => {
  return (
    <Center flexDirection="column" gap="24px" h="100%" w="100%">
      <Flex flexDirection="column" gap="8px" maxW="375px" {...containerProps}>
        <Flex gap="8px" alignItems="center">
          <Stars03
            strokeWidth="1.2"
            gradient={{
              direction: 'vertical',
              colors: [
                { offset: '0%', color: '#797DFF' },
                { offset: '100%', color: '#680AF5' },
              ],
            }}
          />
          <KText variant="heading_1">{config.message.title}</KText>
        </Flex>
        {config.message.description && (
          <KText>{config.message.description}</KText>
        )}
        <Flex mt="16px">
          <StepLoader
            defaultDuration={defaultDuration}
            steps={config.steps}
            // StepItem centres each row; left-align it (ENG-3738).
            styleConfig={{ container: 'justify-start text-left' }}
          />
        </Flex>
      </Flex>
    </Center>
  );
};
